import { ComponentProps } from 'react';
import classNames from 'classnames';
import { Skeleton } from '@mui/material';
import './NoteRowHeaderItem.scss';

interface NoteRowHeaderItemSkeletonProps {
    className?: string;
    icon: React.ReactNode;
}

export function NoteRowHeaderItemSkeleton({
    className,
    icon,
    ...skeletonProps
}: NoteRowHeaderItemSkeletonProps & ComponentProps<typeof Skeleton>) {
    return (
        <div data-testid="SkeletonIconText" className={classNames('NoteRowHeaderItem', className)}>
            <div className="NoteRowHeaderItem__icon">{icon}</div>
            <p className="NoteRowHeaderItem__text">
                <Skeleton {...skeletonProps} variant="text" />
            </p>
        </div>
    );
}
